export default "__VITE_ASSET__c74468b6__"